class Accordion extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button.collapsible');
      this.content = this.querySelector('.content');
  
      this.handleToggle = this.handleToggle.bind(this);
      this.button?.addEventListener('click', this.handleToggle);
    }
  
    handleToggle = (e) => {
      e.preventDefault();
      let accordion_items = document.querySelectorAll('accordion-item');
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        this.content.style.maxHeight = null;
      } else if (
        this.parentElement?.parentElement?.classList.contains('active')
      ) {
        this.classList.add('active');
        this.content.style.maxHeight = this.content.scrollHeight + 'px';
      } else {
        for (let i = 0; i < accordion_items.length; i++) {
          accordion_items[i].classList.remove('active');
        }
        this.classList.add('active');
        this.content.style.maxHeight = this.content.scrollHeight + 'px';
      }
      var x = this.button?.querySelector('.plus-icon');
      if (x) {
        if (x.style.display === 'none') {
          x.style.display = 'block';
        } else {
          x.style.display = 'none';
        }
      }
    };
  }
  
  customElements.define('accordion-item', Accordion);